import { MapPin, PencilRuler, Sprout } from "lucide-react";
import Reveal from "@/components/Reveal";
import { COMPANY } from "@/lib/site";

const FACTS = [
  {
    icon: PencilRuler,
    title: "What we do",
    body: "We design and build consumer mobile applications, taking products from first sketch to finished app.",
    testId: "about-fact-what",
  },
  {
    icon: MapPin,
    title: "Where we are",
    body: `${COMPANY.location} — our home base.`,
    testId: "about-fact-where",
  },
  {
    icon: Sprout,
    title: "What we built",
    body: "NomNom: AI Calorie Tracker, our nutrition and wellness companion — available now on the App Store and Google Play.",
    testId: "about-fact-building",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 py-24 sm:py-28" data-testid="about-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-nom-coral" data-testid="about-eyebrow">
            About Nom Apps LLC
          </p>
          <h2 className="mt-4 max-w-3xl font-display text-3xl font-semibold leading-tight tracking-tight text-nom-ink sm:text-4xl">
            A Wisconsin software company with a warm approach to wellness.
          </h2>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-nom-inkSoft sm:text-lg" data-testid="about-body">
            {COMPANY.legalName} is a Wisconsin limited liability company based in {COMPANY.location}. We
            build consumer apps designed to make taking care of yourself feel lighthearted and doable — starting with
            NomNom, which pairs practical tracking with a companion who genuinely reacts to your day.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {FACTS.map((fact, i) => (
            <Reveal key={fact.title} delay={0.1 + i * 0.1} className="h-full">
              <div
                className="h-full rounded-[28px] border border-nom-border bg-white p-7 shadow-nom transition-all duration-300 hover:-translate-y-1 hover:shadow-nomLg"
                data-testid={fact.testId}
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-nom-peach text-nom-coral">
                  <fact.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-nom-ink">{fact.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-nom-inkSoft">{fact.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
